/* eslint-disable @upgrade/no-template-literal-font-size */
import styled, { css } from 'styled-components';
const TRANSITION_DURATION = 0.15;
const SPINNER_CONTAINER_HEIGHT = 3;
const zIndexTransition = css`
  z-index 0s linear ${({
  $delay,
  $active
}) => `${$active ? 0 : $delay / 1000 + TRANSITION_DURATION}s`}
`;
const delayedVisibilityCss = css`
  transition:
    opacity ${TRANSITION_DURATION}s linear ${({
  $delay
}) => `${$delay / 1000}s`},
    visibility ${TRANSITION_DURATION}s linear ${({
  $delay,
  $active
}) => `${$active ? 0 : $delay / 1000}s`},
    ${zIndexTransition};
  visibility: ${({
  $active
}) => $active ? 'visible' : 'hidden'};
`;
export const LoadingSpinner = styled.svg`
  position: ${({
  $fixed
}) => $fixed ? 'fixed' : 'absolute'} !important;
  z-index: ${({
  $active,
  theme
}) => $active ? theme.zIndex.spinner + 1 : '0'};
  opacity: ${({
  $active
}) => $active ? '1' : '0'};
  ${delayedVisibilityCss}
`;
export default styled.div`
  position: ${({
  $fixed
}) => $fixed ? 'fixed' : 'relative'};
  transition: ${zIndexTransition};

  &,
  &:before,
  &:after {
    z-index: ${({
  $active,
  theme
}) => $active ? theme.zIndex.spinner : '0'};
  }

  &:before,
  &:after {
    position: ${({
  $fixed
}) => $fixed ? 'fixed' : 'absolute'};
    ${delayedVisibilityCss}
  }

  &:before {
    content: '';
    background: ${props => props.theme.palette.backgroundPrimary};
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    opacity: ${({
  $active
}) => $active ? '.2' : '0'};
  }

  &:after {
    content: '';
    top: calc(50% - ${SPINNER_CONTAINER_HEIGHT / 2}rem);
    left: calc(50% - ${SPINNER_CONTAINER_HEIGHT / 2}rem);
    width: ${SPINNER_CONTAINER_HEIGHT}rem;
    height: ${SPINNER_CONTAINER_HEIGHT}rem;
    border-radius: 50%;
    background-color: ${props => props.theme.palette.backgroundPrimary};
    box-shadow: ${props => props.theme.boxShadowLow};
    opacity: ${({
  $active
}) => $active ? '1' : '0'};
  }
`;
//# sourceMappingURL=styles.js.map